<template>
  <transition v-cloak name="modal">
    <v-modal
      :is-open="$store.state.cprConsent.errorModalVisible"
      :show-close-button="$store.state.cprConsent.showModalCloseButton"
      modal-class="alt-modal"
      @close="close"
    >
      <template #title>
        <h2 data-test-cpr-consent-error-title v-html="vueModel.ErrorModalTitle" />
      </template>
      <template #content>
        <div>
          <p data-test-cpr-consent-error-body v-html="vueModel.ErrorModalText" />
        </div>
      </template>
      <template #buttons>
        <div>
          <div class="row">
            <div class="columns small-12 medium-8 medium-offset-2">
              <button
                class="button large"
                data-test-cpr-consent-error-button
                @click="close"
                v-html="vueModel.ErrorModalButtonText"
              />
            </div>
          </div>
        </div>
      </template>
    </v-modal>
  </transition>
</template>

<script>
export default {
  name: 'CprConsentErrorModal',
  computed: {
    vueModel() {
      return this.$store.state.cprConsent.vueModel;
    }
  },
  methods: {
    close() {
      this.$store.dispatch('cprConsent/closeModalsByCross');
    }
  }
};
</script>
